import React, { useMemo, useState } from "react";
import Button from "../form/Button";
import useFetch from "../../hooks/useFetch";
import { submissionData } from "../../services/applicationFormService";
import SmartFieldRenderer from "../form/SmartFieldRenderer";

const SubmissionDetailsFront = ({ data = {}, close = () => {} }) => {
  const { data: submissionDetails, isLoading } = useFetch({
    dependencies: [],
    fetchFunction: async () => {
      const res = await submissionData({ id: data?._id });
      return res;
    },
  });
  console.log(submissionDetails?.data);
  const detailsData = useMemo(() => {
    const dynamicFieldDetails =
      submissionDetails?.data?.dynamicFieldDetails || [];

    const grouped = dynamicFieldDetails.reduce((acc, item) => {
      const group = item.groupCode;
      const value = {
        label: item.label,
        value: item.valueOfDynamicFormDetails?.value,
      };
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(value);
      return acc;
    }, {});

    return { dynamicData: grouped };
  }, [submissionDetails]);

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-6">
      <h2 className="text-2xl font-bold mb-6 text-center text-primary">
        {submissionDetails?.data?.scholarshipDetails?.title || "Scholarship"}
      </h2>

      {detailsData?.dynamicData?.Student_Personal_Information?.length > 0 && (
        <Section
          icon={"fa-regular fa-user"}
          title="Student Personal Information"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            {detailsData.dynamicData.Student_Personal_Information.map(
              (item, index) => (
                <div key={index}>
                  <strong>{item?.label}: </strong>
                  {item?.value?.charAt(0)?.toUpperCase() +
                    item?.value?.slice(1)}
                </div>
              )
            )}
          </div>
        </Section>
      )}

      {detailsData?.dynamicData?.Parent_Guardian_Information?.length > 0 && (
        <Section
          icon={"fa-regular fa-shield-check"}
          title="Parent/Guardian Information"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            {detailsData.dynamicData.Parent_Guardian_Information.map(
              (item, index) => (
                <div key={index}>
                  <strong>{item?.label}: </strong>
                  {item?.value?.charAt(0)?.toUpperCase() +
                    item?.value?.slice(1)}
                </div>
              )
            )}
          </div>
        </Section>
      )}

      {detailsData?.dynamicData?.School_Information?.length > 0 && (
        <Section icon={"fa-regular fa-school"} title="School Information">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            {detailsData.dynamicData.School_Information.map((item, index) => (
              <div key={index}>
                <strong>{item?.label}: </strong>
                {item?.value?.charAt(0)?.toUpperCase() + item?.value?.slice(1)}
              </div>
            ))}
          </div>
        </Section>
      )}

      {detailsData?.dynamicData?.School_Payment_Information?.length > 0 && (
        <Section
          icon={"fa-regular fa-credit-card-front"}
          title="School Payment Information"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            {detailsData.dynamicData.School_Payment_Information.map(
              (item, index) => (
                <div key={index}>
                  <strong>{item?.label}: </strong>
                  {item?.value?.charAt(0)?.toUpperCase() +
                    item?.value?.slice(1)}
                </div>
              )
            )}
          </div>
        </Section>
      )}

      {detailsData?.dynamicData?.Supporting_Documents?.length > 0 && (
        <Section icon={"fa-regular fa-file-pdf"} title="Supporting Documents">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            {detailsData.dynamicData.Supporting_Documents.map((item, index) => (
              <SmartFieldRenderer
                key={index}
                label={item?.label}
                value={item?.value}
                isFront={true}
              />
            ))}
          </div>
        </Section>
      )}

      {detailsData?.dynamicData?.Certification_and_Authorization?.length >
        0 && (
        <Section icon={"fa-regular fa-shield-check"} title="Consent Document">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
            <SmartFieldRenderer
              label={
                detailsData.dynamicData.Certification_and_Authorization[0]
                  ?.label
              }
              value={
                detailsData.dynamicData.Certification_and_Authorization[0]
                  ?.value
              }
              isFront={true}
            />
          </div>
        </Section>
      )}
    </div>
  );
};

export default SubmissionDetailsFront;
const Section = ({ icon: Icon, title, children }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="shadow-md border border-gray-200">
      <div className="space-y-4 p-5">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          <div className="flex items-center gap-3 text-xl font-semibold text-gray-800">
            <i className={Icon} />
            {title}
          </div>
          {open ? (
            <i className="fa-regular fa-chevron-up" />
          ) : (
            <i className="fa-regular fa-chevron-down" />
          )}
        </div>
        <hr className="my-2" />
        {open && children}
      </div>
    </div>
  );
};
